"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
/**
 * Similar to MUI's Stack. Uniformly spaces the children based on `gap`.
 */

const StackContainer = _styled.default.div(_ref => {
  let {
    spacing,
    direction
  } = _ref;
  return {
    display: 'flex',
    flexDirection: direction === 'column' ? 'column' : 'row',
    gap: `${spacing}px`
  };
});
const Stack = _ref2 => {
  let {
    spacing,
    direction = 'column',
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(StackContainer, Object.assign({}, props, {
    direction: direction,
    spacing: spacing
  }), props.children);
};
var _default = exports.default = Stack;